module.exports = __webpack_public_path__ + "static/img/dazzling-dive-v6-01.7d76fe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dazzling-dive-v6-01.jpg
// module id = 61
// module chunks = 0